import { observer } from 'mobx-react-lite';
import TestResponsePage from './TestResponsePage';
import type { TestResponsePageProps, TestResponsePageValueProps } from './types';

export type { TestResponsePageProps, TestResponsePageValueProps };
export default observer(TestResponsePage); // MANUAL OVERRIDE
